<template>
  <div class="forum-detail-container">
    <el-card class="forum-card" shadow="hover">
      <div class="post-header">
        <h2 class="post-title">
          <span v-if="post.isTop === 1" class="top-tag">置顶</span>
          <span v-if="post.isHot === 1" class="hot-tag">精华</span>
          {{ post.title }}
        </h2>
        <div class="post-meta">
          <span>作者: {{ post.username }}</span>
          <span>发布时间: {{ formatDateTime(post.createTime) }}</span>
          <span>浏览: {{ post.viewCount }}</span>
          <span>回复: {{ post.replyCount }}</span>
        </div>
      </div>
      <el-divider />
      <div class="post-content">
        {{ post.content }}
      </div>
      <el-divider />
      <div class="post-actions">
        <el-button type="primary" @click="replyPost">回复</el-button>
        <el-button v-if="isAdmin" @click="setTop">
          {{ post.isTop === 1 ? '取消置顶' : '置顶' }}
        </el-button>
        <el-button v-if="isAdmin" @click="setHot">
          {{ post.isHot === 1 ? '取消精华' : '精华' }}
        </el-button>
      </div>
    </el-card>

    <el-card class="forum-card" shadow="hover" style="margin-top: 20px;">
      <div slot="header" class="clearfix">
        <span>回帖列表 ({{ replies.length }})</span>
      </div>
      <div class="reply-list">
        <div v-for="(reply, index) in replies" :key="reply.id" class="reply-item">
          <div class="reply-header">
            <span class="reply-author">{{ reply.username || '未知用户' }}</span>
            <span class="reply-time">{{ formatDateTime(reply.createTime) }}</span>
          </div>
          <div class="reply-content">{{ reply.content }}</div>
          <div class="reply-actions">
            <el-button type="text" size="small" @click="replyToReply(reply.id)">回复</el-button>
            <el-button type="text" size="small" v-if="isAdmin" @click="deleteReply(reply.id)">删除</el-button>
          </div>
          <div v-if="reply.replies && reply.replies.length > 0" class="sub-reply-list">
            <div v-for="(subReply, subIndex) in reply.replies" :key="subReply.id" class="sub-reply-item">
              <div class="reply-header">
                <span class="reply-author">{{ subReply.username }}</span>
                <span class="reply-time">{{ formatDateTime(subReply.createTime) }}</span>
              </div>
              <div class="reply-content">{{ subReply.content }}</div>
              <div class="reply-actions">
                <el-button type="text" size="small" @click="replyToReply(subReply.id)">回复</el-button>
                <el-button type="text" size="small" v-if="isAdmin" @click="deleteReply(subReply.id)">删除</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-divider />
      <div class="reply-form">
        <h3>发表回复</h3>
        <el-form :model="replyForm" label-width="80px">
          <el-form-item label="内容">
            <el-input
              type="textarea"
              :rows="4"
              v-model="replyForm.content"
              placeholder="请输入回复内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitReply">提交回复</el-button>
            <el-button @click="cancelReply">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ForumDetail',
  data() {
    return {
      postId: this.$route.params.id,
      post: {
        id: 1,
        title: '澄海3C最新版本更新内容',
        content: '澄海3C最新版本更新了以下内容：\n1. 修复了剑圣技能bug\n2. 调整了光明游侠的攻击力\n3. 新增了游戏内聊天功能\n4. 优化了地图平衡性',
        username: 'admin',
        createTime: '2024-01-01',
        viewCount: 100,
        replyCount: 20,
        isTop: 1,
        isHot: 1
      },
      replies: [
        {
          id: 1,
          username: 'player1',
          content: '这个更新很棒！',
          createTime: '2024-01-01',
          replies: [
            {
              id: 2,
              username: 'admin',
              content: '谢谢支持！',
              createTime: '2024-01-01'
            }
          ]
        },
        {
          id: 3,
          username: 'player2',
          content: '期待更多更新！',
          createTime: '2024-01-02'
        }
      ],
      replyForm: {
        content: '',
        parentId: null
      },
      isAdmin: false
    }
  },
  created() {
    this.fetchPostDetail()
    this.fetchReplies()
    this.checkAdminStatus()
  },
  methods: {
    fetchPostDetail() {
      this.$axios.get(`/forum/post/detail/${this.postId}`).then(res => {
        this.post = res.data
      })
    },
    fetchReplies() {
      this.$axios.get('/forum/reply/list', {
        params: {
          postId: this.postId
        }
      }).then(res => {
        this.replies = res.data
      })
    },
    replyPost() {
      this.replyForm.parentId = null
    },
    replyToReply(replyId) {
      this.replyForm.parentId = replyId
    },
    submitReply() {
      if (!this.replyForm.content.trim()) {
        this.$message.warning('回复内容不能为空')
        return
      }
      // 从localStorage获取当前用户ID，或使用默认值2（player1）
      const user = JSON.parse(localStorage.getItem('user'))
      const userId = user ? user.id : 2
      
      console.log('Submitting reply:', {
        postId: this.postId,
        userId: userId,
        content: this.replyForm.content,
        parentId: this.replyForm.parentId
      })
      
      this.$axios.post('/forum/reply/create', {
        postId: this.postId,
        userId: userId, // 使用当前用户ID或默认值
        content: this.replyForm.content,
        parentId: this.replyForm.parentId
      }).then(res => {
        console.log('Reply response:', res)
        this.$message.success('回复成功')
        this.replyForm.content = ''
        this.replyForm.parentId = null
        this.fetchReplies()
        this.fetchPostDetail() // 更新帖子的回复数
      }).catch(error => {
        console.error('Submit reply error:', error)
        if (error.response) {
          console.error('Error response:', error.response.data)
          this.$message.error('回复失败：' + (error.response.data.message || '请重试'))
        } else {
          this.$message.error('回复失败，请检查网络连接')
        }
      })
    },
    cancelReply() {
      this.replyForm.content = ''
      this.replyForm.parentId = null
    },
    deleteReply(replyId) {
      this.$confirm('确定要删除这条回复吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/forum/reply/delete/${replyId}`).then(res => {
          this.$message.success('删除成功')
          this.fetchReplies()
          this.fetchPostDetail() // 更新帖子的回复数
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    setTop() {
      // 这里可以调用API设置置顶
      // this.$axios.put(`/forum/post/top/${this.postId}`, {
      //   isTop: this.post.isTop === 1 ? 0 : 1
      // }).then(res => {
      //   this.$message.success('操作成功')
      //   this.post.isTop = this.post.isTop === 1 ? 0 : 1
      // })
      this.$message.success('操作成功')
      this.post.isTop = this.post.isTop === 1 ? 0 : 1
    },
    setHot() {
      // 这里可以调用API设置精华
      // this.$axios.put(`/forum/post/hot/${this.postId}`, {
      //   isHot: this.post.isHot === 1 ? 0 : 1
      // }).then(res => {
      //   this.$message.success('操作成功')
      //   this.post.isHot = this.post.isHot === 1 ? 0 : 1
      // })
      this.$message.success('操作成功')
      this.post.isHot = this.post.isHot === 1 ? 0 : 1
    },
    checkAdminStatus() {
      // 这里可以检查用户是否为管理员
      // const role = localStorage.getItem('role')
      // this.isAdmin = role === 'admin'
      this.isAdmin = true // 测试用，实际应该从API获取
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.forum-detail-container {
  padding: 20px 0;
}

.forum-card {
  margin-bottom: 20px;
}

.post-header {
  padding: 10px 0;
}

.post-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.top-tag {
  background-color: #ff4d4f;
  color: white;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 2px;
  margin-right: 5px;
}

.hot-tag {
  background-color: #faad14;
  color: white;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 2px;
  margin-right: 5px;
}

.post-meta {
  font-size: 14px;
  color: #999;
}

.post-meta span {
  margin-right: 15px;
}

.post-content {
  font-size: 16px;
  line-height: 1.8;
  padding: 20px 0;
}

.post-actions {
  padding: 10px 0;
  text-align: right;
}

.reply-list {
  padding: 10px 0;
}

.reply-item {
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}

.reply-item:last-child {
  border-bottom: none;
}

.reply-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.reply-author {
  font-weight: bold;
}

.reply-time {
  color: #999;
  font-size: 14px;
}

.reply-content {
  margin-bottom: 10px;
  line-height: 1.6;
}

.reply-actions {
  text-align: right;
}

.sub-reply-list {
  margin-top: 10px;
  margin-left: 30px;
  padding-left: 10px;
  border-left: 2px solid #e6f7ff;
}

.sub-reply-item {
  padding: 10px 0;
  border-bottom: 1px dashed #f0f0f0;
}

.sub-reply-item:last-child {
  border-bottom: none;
}

.reply-form {
  padding: 10px 0;
}

.reply-form h3 {
  margin-bottom: 15px;
}
</style>